import React, { useEffect, useState, useRef, } from 'react';
import { animated, useSpring } from "react-spring";

function GameTitle() {

  const inkStrokeRef = useRef(null);

  const [inkStrokeLength, setInkStrokeLength] = useState(353.132);

  const [inkStrokeBegin, setInkStrokeBegin] = useState(false);

  const [titleStyle, titleApi] = useSpring(() => ({
    from: {
      transform: "scale(8.0)",
      opacity: 0
    },
    config: { duration: 500 },
    onResolve: setInkStrokeBegin(true)
  }))

  const animatedStroke = useSpring(({
    delay: 1000,
    strokeDasharray: inkStrokeLength,
    strokeDashoffset: inkStrokeBegin ? 0 : inkStrokeLength,
    config: { duration: 1500 },
  }))

  useEffect(() => {
    if (inkStrokeLength != null)
      titleApi.start({
        transform: "scale(1.0)",
        opacity: 1,
      });
  })

  useEffect(() => {
    if (inkStrokeLength == null)
    setInkStrokeLength(inkStrokeRef.current.getTotalLength());
  }, [])

  return (
    <div className='title-wrapper'>
    <animated.div className="md:mx-6 2xl:p-6 flex justify-around mx-4 md:mx-0 2xl:p-0" style={{...titleStyle}}>
        <svg
          className='z-0'
          width="204.54425mm"
          height="24.57716mm"
          viewBox="0 0 204.54426 40"
          version="1.1"
          id="incognito-title"
          xmlns="http://www.w3.org/2000/svg">
          <defs
            id="defs2">
            <pattern
              patternUnits="userSpaceOnUse"
              width="2"
              height="1"
              patternTransform="translate(0,0) scale(10,10)"
              id="Strips1_1">
              <rect
                x="0"
                y="-0.5"
                width="1"
                height="2"
                id="rect3493" />
            </pattern>
            <rect
              x="-21.285303"
              y="-53.773399"
              width="961.19946"
              height="555.65845"
              id="rect271" />
          </defs>
          <g
            id="layer1"
            transform="translate(3.9677412,1.9755898)">
            <text
              transform="scale(0.26458333)"
              id="text269" />
            <text
              x="13.783764"
              y="31.067039"
              id="text277"><tspan
                id="tspan275"
                x="13.783764"
                y="31.067039">INCOGNITO</tspan></text>
            <path
              id="rect2509"
              d="m 9.9363444,4.951119 a 1.1048642,1.555151 0 0 0 -1.1032918,1.5559774 v 2.3853841 h 2.2086504 v -0.8330241 h 3.407544 v -3.1083374 z m 6.0228886,0 v 3.1083374 h 178.081637 v -3.1083374 z m 179.591617,0 v 3.1083374 h 3.40755 v 1.1983764 h 2.20865 v -2.7507364 a 1.1048642,1.555151 0 0 0 -1.10329,-1.5559774 z m -186.7177974,5.44928 v 20.585823 h 2.2086504 v -20.585823 z m 190.1253474,0.365352 v 20.585824 h 2.20865 v -20.585824 z m -190.1253474,21.72839 v 2.750736 a 1.1048642,1.555151 0 0 0 1.1032918,1.555977 h 3.1905026 v -3.111437 h -2.085144 v -1.195276 z m 190.1253474,0.365352 v 0.829924 h -4.73201 v 3.111437 h 5.83737 a 1.1048642,1.555151 0 0 0 1.10329,-1.555977 v -2.385384 z m -184.323634,0.829924 v 3.111437 h 178.084224 v -3.111437 z" />
          </g>
          <animated.path
            style={{...animatedStroke}}
            d="m 15.860936,25.845055 c -0.697631,0.157642 -11.5109143,1.261149 -14.1270312,0.315286 -2.61611702,-0.945861 5.9298651,13.242084 12.3829532,12.453866 6.453088,-0.788219 14.99907,-44.2979261 9.941244,-36.4157331 -5.057826,7.8821931 -9.243613,36.8886641 -2.267301,35.3122271 6.976311,-1.57644 8.022759,-20.966635 8.022759,-20.966635 0,0 -2.092895,21.124279 -4.011379,21.59721 -1.918487,0.472931 3.662563,-22.070142 13.254992,-20.651347 9.592429,1.418794 -0.348816,22.227785 5.406642,20.336059 5.755456,-1.891727 12.034138,-24.750087 12.208546,-32.3169928 0.174408,-7.5669054 -0.523224,31.3711298 -1.918487,32.6322808 -1.395261,1.261149 -0.523222,-17.656113 15.173479,-20.493703 15.696703,-2.83759 -42.03228,13.87266 1.569671,19.705484"
            id="titleInkStroke"
            ref={inkStrokeRef}
            />
        </svg>
    </animated.div>
    </div>
  );
}

export default GameTitle;
